import {
    Component,
    Input,
    Output,
    EventEmitter,
    TemplateRef,
    ViewChild,
    ElementRef,
    forwardRef,
    OnInit,
    OnDestroy
} from '@angular/core';
import { ToolBarToolComponent } from '@progress/kendo-angular-toolbar';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
// import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';

@Component({
    providers: [{ provide: ToolBarToolComponent, useExisting: forwardRef(() => GridSearchToolComponent) }],
    selector: 'grid-search-tool',
    template: `
        <ng-template #toolbarTemplate>
            <div class="input-group searchbar" style="display:flex;">
            <input kendoTextBox placeholder="Search" (input)="onChange($event);" [tabindex]="tabindex" [value]="search$ | async" class="border-0 rounded-0">
            </div>
        </ng-template>
    `,
    standalone: false
})
export class GridSearchToolComponent extends ToolBarToolComponent implements OnInit, OnDestroy {
    public tabindex = -1;

    @Input() public text: string;
    // @Input() public value: string;
    @Input() public itemDisabled: (itemArgs: { dataItem: any; index: number }) => boolean;
    @Input() public disabled: boolean;
    // @Output() public onChange = new EventEmitter();
    @Input() public search$: Subject<string>;
    private change$ = new Subject<InputEvent>();
    private subscription: Subscription;
  
    @ViewChild('toolbarTemplate', { static: true }) public toolbarTemplate: TemplateRef<any>;

    constructor() {
        super();
    }

    public ngOnInit() {

        this.subscription = this.change$.pipe(
            map(event => (event.target as HTMLInputElement).value),
            debounceTime(500),
            distinctUntilChanged()
        ).subscribe( (value)=>{
            this.search$?.next(value);
        });
    }

    public ngOnDestroy() {
        this.subscription?.unsubscribe();
    }

    public onChange(event: Event) {
        this.change$.next(event as InputEvent);
        // this.search$?.next((event.target as HTMLInputElement).value);
    }
    
}
